import React, { Component, Fragment } from 'react';
import { Query } from '@apollo/client/react/components';
import Navbar from '../../components/Navbar';
import ImportForm from './components/ImportForm';
import { Loader } from '../../components/Loader';
import { readAllUsers } from './api';
import { connect } from 'react-redux';

class ImportVerification extends Component<any, any> {
  render() {
    return (
      <Fragment>
        <Navbar />
        <Query query={readAllUsers}>
          {({ loading, error, data }: any) => {
            if (loading) return <Loader />;
            return (
              <ImportForm
                users={data.readAllApplicationUsers}
                currentRole={this.props.currentRole}
                userId={this.props.userId}
                adId={this.props.adId}
              />
            );
          }}
        </Query>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  currentRole: state.user.currentRole,
  userId: state.user.id,
  adId: state.user.adId,
});

export default connect(mapStateToProps)(ImportVerification);
